module.exports = __webpack_public_path__ + "static/media/cambridge.53906724.png";